import type {LocaleMessages} from './types';

export const it: LocaleMessages = {
    common: {
        actions: {
            save: 'Salva',
            cancel: 'Annulla',
            delete: 'Elimina',
            edit: 'Modifica',
            update: 'Aggiorna',
            create: 'Crea',
            submit: 'Invia',
            reset: 'Reimposta',
            clear: 'Cancella',
            search: 'Cerca',
            filter: 'Filtra',
            sort: 'Ordina',
            refresh: 'Aggiorna',
            reload: 'Ricarica',
            back: 'Indietro',
            next: 'Avanti',
            previous: 'Precedente',
            continue: 'Continua',
            finish: 'Termina',
            close: 'Chiudi',
            open: 'Apri',
            show: 'Mostra',
            hide: 'Nascondi',
            copy: 'Copia',
            paste: 'Incolla',
            cut: 'Ritaglia',
            select: 'Seleziona',
            selectAll: 'Seleziona tutto',
            deselect: 'Deseleziona',
            confirm: 'Conferma',
            deny: 'Rifiuta',
            approve: 'Approva',
            reject: 'Respingi',
            retry: 'Riprova',
            undo: 'Annulla',
            redo: 'Ripeti'
        },
        status: {
            loading: 'Caricamento...',
            success: 'Successo',
            error: 'Errore',
            warning: 'Avviso',
            info: 'Informazione',
            pending: 'In attesa',
            completed: 'Completato',
            failed: 'Fallito',
            cancelled: 'Annullato',
            active: 'Attivo',
            inactive: 'Inattivo',
            enabled: 'Abilitato',
            disabled: 'Disabilitato',
            online: 'Online',
            offline: 'Offline',
            connected: 'Connesso',
            disconnected: 'Disconnesso'
        },
        timeAgo: {
            justNow: 'Proprio ora',
            minutesAgo: '{count} minuto/i fa',
            hoursAgo: '{count} ora/e fa',
            daysAgo: '{count} giorno/i fa',
            weeksAgo: '{count} settimana/e fa',
            monthsAgo: '{count} mese/i fa',
            yearsAgo: '{count} anno/i fa'
        },
        navigation: {
            home: 'Home',
            dashboard: 'Dashboard',
            profile: 'Profilo',
            settings: 'Impostazioni',
            help: 'Aiuto',
            support: 'Supporto',
            documentation: 'Documentazione',
            feedback: 'Feedback',
            about: 'Info',
            privacy: 'Privacy',
            terms: 'Termini',
            contact: 'Contatto'
        },
        general: {
            yes: 'Sì',
            no: 'No',
            ok: 'OK',
            maybe: 'Forse',
            none: 'Nessuno',
            all: 'Tutto',
            other: 'Altro',
            unknown: 'Sconosciuto',
            optional: 'Opzionale',
            required: 'Richiesto',
            recommended: 'Raccomandato',
            advanced: 'Avanzato',
            basic: 'Base',
            custom: 'Personalizzato',
            default: 'Predefinito',
            example: 'Esempio',
            placeholder: 'Segnaposto',
            noData: 'Nessun dato',
            noResults: 'Nessun risultato',
            empty: 'Vuoto',
            total: 'Totale',
            subtotal: 'Subtotale',
            count: 'Conteggio',
            limit: 'Limite',
            unlimited: 'Illimitato'
        }
    },
    auth: {
        signIn: {
            title: 'Accedi',
            subtitle: 'Accedi al tuo account',
            emailLabel: 'Email',
            emailPlaceholder: 'Inserisci la tua email',
            usernameLabel: 'Nome utente',
            usernamePlaceholder: 'Inserisci il tuo nome utente',
            passwordLabel: 'Password',
            passwordPlaceholder: 'Inserisci la tua password',
            rememberMe: 'Ricordami',
            forgotPassword: 'Password dimenticata?',
            signInButton: 'Accedi',
            signInWithProvider: 'Accedi con {provider}',
            orDivider: 'o',
            noAccount: 'Non hai un account?',
            createAccount: 'Crea account',
            success: 'Accesso effettuato con successo',
            welcomeBack: 'Bentornato!'
        },
        signUp: {
            title: 'Registrati',
            subtitle: 'Crea il tuo account',
            firstNameLabel: 'Nome',
            firstNamePlaceholder: 'Inserisci il tuo nome',
            lastNameLabel: 'Cognome',
            lastNamePlaceholder: 'Inserisci il tuo cognome',
            emailLabel: 'Email',
            emailPlaceholder: 'Inserisci la tua email',
            usernameLabel: 'Nome utente',
            usernamePlaceholder: 'Scegli un nome utente',
            passwordLabel: 'Password',
            passwordPlaceholder: 'Crea una password',
            confirmPasswordLabel: 'Conferma password',
            confirmPasswordPlaceholder: 'Conferma la tua password',
            phoneLabel: 'Telefono',
            phonePlaceholder: 'Inserisci il tuo numero di telefono',
            signUpButton: 'Registrati',
            signUpWithProvider: 'Registrati con {provider}',
            orDivider: 'o',
            hasAccount: 'Hai già un account?',
            signInLink: 'Accedi',
            termsAcceptance: 'Accetto i {terms} e l\'informativa sulla {privacy}',
            termsOfService: 'Termini di servizio',
            privacyPolicy: 'Privacy',
            success: 'Registrazione completata',
            welcomeMessage: 'Benvenuto!'
        },
        passwordReset: {
            title: 'Reimposta password',
            subtitle: 'Ti invieremo un link per reimpostare la password',
            emailLabel: 'Email',
            emailPlaceholder: 'Inserisci la tua email',
            sendResetButton: 'Invia link di ripristino',
            backToSignIn: 'Torna all\'accesso',
            success: 'Link inviato!',
            checkEmail: 'Controlla la tua email per il link di ripristino',
            resetPassword: 'Imposta nuova password',
            newPasswordLabel: 'Nuova password',
            newPasswordPlaceholder: 'Inserisci la nuova password',
            confirmNewPasswordLabel: 'Conferma nuova password',
            confirmNewPasswordPlaceholder: 'Conferma la nuova password',
            resetButton: 'Reimposta password',
            passwordUpdated: 'Password aggiornata con successo'
        },
        mfa: {
            title: 'Autenticazione a due fattori',
            subtitle: 'Inserisci il codice dalla tua app di autenticazione',
            codeLabel: 'Codice di verifica',
            codePlaceholder: 'Inserisci il codice a 6 cifre',
            verifyButton: 'Verifica',
            resendCode: 'Invia nuovamente il codice',
            useBackupCode: 'Usa codice di backup',
            backupCodeLabel: 'Codice di backup',
            backupCodePlaceholder: 'Inserisci il codice di backup',
            useAuthenticator: 'Usa app di autenticazione',
            success: 'Verificato con successo',
            setup: {
                title: 'Configura autenticazione a due fattori',
                subtitle: 'Aggiungi un ulteriore livello di sicurezza al tuo account',
                step1: 'Scarica un\'app di autenticazione',
                step2: 'Scansiona il codice QR',
                step3: 'Inserisci il codice di verifica',
                downloadApp: 'Scarica Google Authenticator o Authy',
                scanQR: 'Scansiona questo codice QR con la tua app',
                enterCode: 'Inserisci il codice a 6 cifre dalla tua app',
                manualEntry: 'Inserimento manuale',
                secretKey: 'Chiave segreta',
                verificationCode: 'Codice di verifica',
                enableButton: 'Abilita 2FA',
                backupCodes: 'Codici di backup',
                saveBackupCodes: 'Salva questi codici in un posto sicuro',
                backupCodesWarning: 'Questi codici possono essere usati solo una volta'
            }
        },
        passkeys: {
            title: 'Passkey',
            subtitle: 'Accedi in modo sicuro senza password',
            setup: 'Configura passkey',
            use: 'Usa passkey',
            notSupported: 'Passkey non supportato in questo browser',
            setupButton: 'Configura passkey',
            useButton: 'Usa passkey',
            success: 'Passkey configurato con successo',
            registered: 'Passkey registrato',
            manage: {
                title: 'Gestisci passkey',
                noPasskeys: 'Nessun passkey configurato',
                addPasskey: 'Aggiungi passkey',
                deviceName: 'Nome dispositivo',
                createdAt: 'Creato il',
                lastUsed: 'Ultimo utilizzo',
                remove: 'Rimuovi',
                removeConfirm: 'Sei sicuro di voler rimuovere questo passkey?'
            }
        },
        oauth: {
            signInWith: 'Accedi con {provider}',
            signUpWith: 'Registrati con {provider}',
            continueWith: 'Continua con {provider}',
            connecting: 'Connessione...',
            success: 'Connesso con successo',
            error: 'Errore di connessione',
            cancelled: 'Connessione annullata',
            providers: {
                google: 'Google',
                github: 'GitHub',
                microsoft: 'Microsoft',
                facebook: 'Facebook',
                apple: 'Apple',
                twitter: 'Twitter',
                linkedin: 'LinkedIn',
                discord: 'Discord',
                slack: 'Slack',
                spotify: 'Spotify'
            }
        },
        verification: {
            email: {
                title: 'Verifica email',
                subtitle: 'Abbiamo inviato un link di verifica alla tua email',
                checkEmail: 'Controlla la tua email',
                resendEmail: 'Invia nuovamente email',
                changeEmail: 'Cambia email',
                success: 'Email verificata',
                verified: 'Email verificata con successo'
            },
            phone: {
                title: 'Verifica telefono',
                subtitle: 'Inserisci il codice inviato al tuo telefono',
                codeLabel: 'Codice di verifica',
                codePlaceholder: 'Inserisci il codice a 6 cifre',
                resendCode: 'Invia nuovamente codice',
                verifyButton: 'Verifica',
                success: 'Telefono verificato',
                verified: 'Telefono verificato con successo'
            }
        },
        magicLink: {
            title: 'Link magico',
            subtitle: 'Ti invieremo un link sicuro per accedere',
            emailLabel: 'Email',
            emailPlaceholder: 'Inserisci la tua email',
            sendLinkButton: 'Invia link magico',
            checkEmail: 'Controlla la tua email per il link magico',
            success: 'Link magico inviato',
            expired: 'Link magico scaduto',
            invalid: 'Link magico non valido'
        },
        logout: {
            title: 'Disconnetti',
            subtitle: 'Sei sicuro di volerti disconnettere?',
            button: 'Disconnetti',
            confirm: 'Sì, disconnetti',
            success: 'Disconnesso con successo',
            goodbye: 'Arrivederci!'
        },
        session: {
            expired: 'Sessione scaduta',
            invalid: 'Sessione non valida',
            refresh: 'Aggiorna sessione',
            refreshing: 'Aggiornamento sessione...',
            multipleWarning: 'Rilevate sessioni multiple',
            deviceLimit: 'Limite dispositivi raggiunto'
        }
    },
    user: {
        profile: {
            title: 'Profilo',
            personalInfo: 'Informazioni personali',
            accountInfo: 'Informazioni account',
            security: 'Sicurezza',
            preferences: 'Preferenze',
            firstName: 'Nome',
            lastName: 'Cognome',
            email: 'Email',
            username: 'Nome utente',
            phone: 'Telefono',
            bio: 'Biografia',
            website: 'Sito web',
            location: 'Località',
            timezone: 'Fuso orario',
            language: 'Lingua',
            avatar: 'Avatar',
            changeAvatar: 'Cambia avatar',
            removeAvatar: 'Rimuovi avatar',
            updateProfile: 'Aggiorna profilo',
            profileUpdated: 'Profilo aggiornato'
        },
        security: {
            title: 'Sicurezza',
            changePassword: 'Cambia password',
            currentPassword: 'Password attuale',
            newPassword: 'Nuova password',
            confirmPassword: 'Conferma password',
            passwordStrength: 'Forza password',
            passwordRequirements: 'Requisiti password',
            twoFactor: 'Autenticazione a due fattori',
            enableTwoFactor: 'Abilita 2FA',
            disableTwoFactor: 'Disabilita 2FA',
            twoFactorEnabled: '2FA abilitato',
            twoFactorDisabled: '2FA disabilitato',
            backupCodes: 'Codici di backup',
            viewBackupCodes: 'Visualizza codici di backup',
            regenerateBackupCodes: 'Rigenera codici di backup',
            devices: 'Dispositivi',
            trustedDevices: 'Dispositivi fidati',
            removeDevice: 'Rimuovi dispositivo',
            deviceRemoved: 'Dispositivo rimosso',
            sessions: 'Sessioni',
            activeSessions: 'Sessioni attive',
            terminateSession: 'Termina sessione',
            terminateAllSessions: 'Termina tutte le sessioni',
            sessionTerminated: 'Sessione terminata',
            connectedAccounts: 'Account connessi',
            disconnect: 'Disconnetti',
            accountDisconnected: 'Account disconnesso',
            deleteAccount: 'Elimina account',
            deleteAccountWarning: 'Questa azione non può essere annullata',
            deleteAccountConfirm: 'Elimina il mio account',
            accountDeleted: 'Account eliminato'
        },
        preferences: {
            title: 'Preferenze',
            theme: 'Tema',
            lightMode: 'Modalità chiara',
            darkMode: 'Modalità scura',
            systemMode: 'Sistema',
            notifications: 'Notifiche',
            emailNotifications: 'Notifiche email',
            pushNotifications: 'Notifiche push',
            smsNotifications: 'Notifiche SMS',
            marketingEmails: 'Email di marketing',
            securityAlerts: 'Avvisi di sicurezza',
            accountActivity: 'Attività account',
            productUpdates: 'Aggiornamenti prodotto',
            preferences: 'Preferenze',
            preferencesUpdated: 'Preferenze aggiornate'
        }
    },
    organization: {
        general: {
            title: 'Organizzazione',
            name: 'Nome',
            description: 'Descrizione',
            website: 'Sito web',
            logo: 'Logo',
            settings: 'Impostazioni',
            members: 'Membri',
            billing: 'Fatturazione',
            usage: 'Utilizzo',
            security: 'Sicurezza',
            integrations: 'Integrazioni',
            audit: 'Audit',
            support: 'Supporto'
        },
        profile: {
            title: 'Profilo organizzazione',
            updateOrganization: 'Aggiorna organizzazione',
            organizationUpdated: 'Organizzazione aggiornata',
            logo: 'Logo',
            changeLogo: 'Cambia logo',
            removeLogo: 'Rimuovi logo',
            brandColors: 'Colori brand',
            primaryColor: 'Colore primario',
            secondaryColor: 'Colore secondario',
            customBranding: 'Branding personalizzato',
            domain: 'Dominio',
            customDomain: 'Dominio personalizzato',
            verifyDomain: 'Verifica dominio',
            domainVerified: 'Dominio verificato',
            domainPending: 'Dominio in attesa di verifica',
            contact: 'Contatto',
            contactEmail: 'Email di contatto',
            supportUrl: 'URL supporto',
            address: 'Indirizzo',
            country: 'Paese',
            timezone: 'Fuso orario'
        },
        members: {
            title: 'Membri',
            totalMembers: 'Membri totali',
            activeMembers: 'Membri attivi',
            pendingInvitations: 'Inviti in attesa',
            roles: 'Ruoli',
            permissions: 'Permessi',
            inviteMember: 'Invita membro',
            inviteMembers: 'Invita membri',
            emailAddress: 'Indirizzo email',
            role: 'Ruolo',
            customMessage: 'Messaggio personalizzato',
            sendInvitation: 'Invia invito',
            invitationSent: 'Invito inviato',
            resendInvitation: 'Invia nuovamente invito',
            cancelInvitation: 'Annulla invito',
            invitationCancelled: 'Invito annullato',
            memberName: 'Nome membro',
            memberEmail: 'Email membro',
            memberRole: 'Ruolo membro',
            memberStatus: 'Stato membro',
            memberJoined: 'Membro dal',
            lastActive: 'Ultimo accesso',
            changeRole: 'Cambia ruolo',
            removeMember: 'Rimuovi membro',
            removeMemberConfirm: 'Sei sicuro di voler rimuovere questo membro?',
            memberRemoved: 'Membro rimosso',
            transferOwnership: 'Trasferisci proprietà',
            transferOwnershipConfirm: 'Sei sicuro di voler trasferire la proprietà?',
            ownershipTransferred: 'Proprietà trasferita',
            bulkActions: 'Azioni multiple',
            selectAll: 'Seleziona tutto',
            selectedMembers: 'Membri selezionati',
            bulkRemove: 'Rimuovi selezionati',
            bulkChangeRole: 'Cambia ruolo selezionati',
            export: 'Esporta',
            exportMembers: 'Esporta membri'
        },
        roles: {
            title: 'Ruoli',
            createRole: 'Crea ruolo',
            editRole: 'Modifica ruolo',
            deleteRole: 'Elimina ruolo',
            roleName: 'Nome ruolo',
            roleDescription: 'Descrizione ruolo',
            permissions: 'Permessi',
            systemPermissions: 'Permessi di sistema',
            organizationPermissions: 'Permessi organizzazione',
            memberPermissions: 'Permessi membri',
            billingPermissions: 'Permessi fatturazione',
            defaultRole: 'Ruolo predefinito',
            customRole: 'Ruolo personalizzato',
            roleCreated: 'Ruolo creato',
            roleUpdated: 'Ruolo aggiornato',
            roleDeleted: 'Ruolo eliminato',
            assignRole: 'Assegna ruolo',
            unassignRole: 'Rimuovi ruolo',
            roleAssigned: 'Ruolo assegnato',
            roleUnassigned: 'Ruolo rimosso',
            owner: 'Proprietario',
            admin: 'Amministratore',
            member: 'Membro',
            guest: 'Ospite',
            viewer: 'Visualizzatore',
            editor: 'Editor',
            manager: 'Manager'
        },
        settings: {
            title: 'Impostazioni',
            general: 'Generale',
            authentication: 'Autenticazione',
            security: 'Sicurezza',
            integrations: 'Integrazioni',
            advanced: 'Avanzate',
            allowPublicSignup: 'Consenti registrazione pubblica',
            requireEmailVerification: 'Richiedi verifica email',
            allowUsernameSignup: 'Consenti registrazione con nome utente',
            passwordPolicy: 'Politica password',
            minPasswordLength: 'Lunghezza minima password',
            requireUppercase: 'Richiedi maiuscole',
            requireLowercase: 'Richiedi minuscole',
            requireNumbers: 'Richiedi numeri',
            requireSymbols: 'Richiedi simboli',
            sessionDuration: 'Durata sessione',
            mfaRequired: 'MFA obbligatorio',
            allowedDomains: 'Domini consentiti',
            blockedDomains: 'Domini bloccati',
            ipWhitelist: 'Whitelist IP',
            ssoEnabled: 'SSO abilitato',
            ssoProvider: 'Provider SSO',
            auditLogRetention: 'Retention log audit',
            dataExport: 'Esportazione dati',
            deleteOrganization: 'Elimina organizzazione',
            deleteOrganizationWarning: 'Questa azione eliminerà permanentemente l\'organizzazione',
            deleteOrganizationConfirm: 'Elimina organizzazione',
            organizationDeleted: 'Organizzazione eliminata',
            settingsUpdated: 'Impostazioni aggiornate'
        },
        billing: {
            title: 'Fatturazione',
            plan: 'Piano',
            currentPlan: 'Piano attuale',
            usage: 'Utilizzo',
            billing: 'Fatturazione',
            invoices: 'Fatture',
            paymentMethod: 'Metodo di pagamento',
            subscription: 'Abbonamento',
            seats: 'Posti',
            usedSeats: 'Posti utilizzati',
            availableSeats: 'Posti disponibili',
            addSeats: 'Aggiungi posti',
            removeSeats: 'Rimuovi posti',
            monthlyBilling: 'Fatturazione mensile',
            yearlyBilling: 'Fatturazione annuale',
            upgrade: 'Aggiorna',
            downgrade: 'Declassa',
            cancel: 'Annulla',
            pauseSubscription: 'Pausa abbonamento',
            resumeSubscription: 'Riprendi abbonamento',
            billingHistory: 'Storico fatturazione',
            downloadInvoice: 'Scarica fattura',
            updatePaymentMethod: 'Aggiorna metodo di pagamento',
            paymentMethodUpdated: 'Metodo di pagamento aggiornato',
            subscriptionUpdated: 'Abbonamento aggiornato',
            subscriptionCancelled: 'Abbonamento annullato',
            subscriptionPaused: 'Abbonamento in pausa',
            subscriptionResumed: 'Abbonamento ripreso',
            trialExpired: 'Prova scaduta',
            trialDaysLeft: 'Giorni di prova rimanenti',
            upgradeNow: 'Aggiorna ora'
        },
        invitations: {
            title: 'Inviti',
            youreInvited: 'Sei invitato',
            invitedBy: 'Invitato da',
            invitedTo: 'Invitato a',
            roleOffered: 'Ruolo offerto',
            acceptInvitation: 'Accetta invito',
            declineInvitation: 'Rifiuta invito',
            invitationAccepted: 'Invito accettato',
            invitationDeclined: 'Invito rifiutato',
            invitationExpired: 'Invito scaduto',
            invitationInvalid: 'Invito non valido',
            alreadyMember: 'Già membro',
            pendingInvitations: 'Inviti in attesa',
            sentInvitations: 'Inviti inviati',
            receivedInvitations: 'Inviti ricevuti',
            invitationDetails: 'Dettagli invito',
            expiresAt: 'Scade il',
            customMessage: 'Messaggio personalizzato'
        }
    },
    validation: {
        required: 'Questo campo è obbligatorio',
        email: 'Inserisci un indirizzo email valido',
        phone: 'Inserisci un numero di telefono valido',
        url: 'Inserisci un URL valido',
        minLength: 'Deve contenere almeno {min} caratteri',
        maxLength: 'Non può superare {max} caratteri',
        min: 'Il valore minimo è {min}',
        max: 'Il valore massimo è {max}',
        pattern: 'Formato non valido',
        passwordMismatch: 'Le password non corrispondono',
        invalidFormat: 'Formato non valido',
        invalid: 'Non valido',
        tooShort: 'Troppo corto',
        tooLong: 'Troppo lungo',
        tooSmall: 'Troppo piccolo',
        tooLarge: 'Troppo grande',
        notFound: 'Non trovato',
        alreadyExists: 'Già esistente',
        expired: 'Scaduto',
        weak: 'Debole',
        strong: 'Forte',
        medium: 'Medio',
        passwordStrength: {
            veryWeak: 'Molto debole',
            weak: 'Debole',
            fair: 'Discreta',
            good: 'Buona',
            strong: 'Forte'
        },
        passwordRequirements: {
            minLength: 'Almeno {min} caratteri',
            uppercase: 'Almeno una maiuscola',
            lowercase: 'Almeno una minuscola',
            number: 'Almeno un numero',
            symbol: 'Almeno un simbolo'
        }
    },
    errors: {
        generic: {
            unknown: 'Si è verificato un errore sconosciuto',
            network: 'Errore di rete',
            timeout: 'Timeout della richiesta',
            serverError: 'Errore del server',
            notFound: 'Non trovato',
            unauthorized: 'Non autorizzato',
            forbidden: 'Accesso negato',
            badRequest: 'Richiesta non valida',
            conflict: 'Conflitto',
            tooManyRequests: 'Troppe richieste',
            maintenance: 'Sistema in manutenzione',
            offline: 'Nessuna connessione internet'
        },
        auth: {
            invalidCredentials: 'Credenziali non valide',
            accountLocked: 'Account bloccato',
            accountDisabled: 'Account disabilitato',
            accountNotVerified: 'Account non verificato',
            sessionExpired: 'Sessione scaduta',
            invalidToken: 'Token non valido',
            mfaRequired: 'Autenticazione a due fattori richiesta',
            invalidMfaCode: 'Codice MFA non valido',
            passkeyNotSupported: 'Passkey non supportato',
            passkeyFailed: 'Autenticazione passkey fallita',
            oauthFailed: 'Autenticazione OAuth fallita',
            oauthCancelled: 'Autenticazione OAuth annullata',
            magicLinkExpired: 'Link magico scaduto',
            magicLinkInvalid: 'Link magico non valido',
            passwordTooWeak: 'Password troppo debole',
            passwordReused: 'Password già utilizzata',
            emailNotVerified: 'Email non verificata',
            phoneNotVerified: 'Telefono non verificato',
            invitationExpired: 'Invito scaduto',
            invitationInvalid: 'Invito non valido',
            invitationAlreadyAccepted: 'Invito già accettato'
        },
        organization: {
            notFound: 'Organizzazione non trovata',
            accessDenied: 'Accesso negato all\'organizzazione',
            memberLimitReached: 'Limite membri raggiunto',
            ownerRequired: 'Proprietario richiesto',
            cannotRemoveOwner: 'Impossibile rimuovere il proprietario',
            cannotRemoveSelf: 'Impossibile rimuovere se stessi',
            alreadyMember: 'Già membro dell\'organizzazione',
            notMember: 'Non membro dell\'organizzazione',
            invalidRole: 'Ruolo non valido',
            roleNotFound: 'Ruolo non trovato',
            domainTaken: 'Dominio già utilizzato',
            domainInvalid: 'Dominio non valido',
            seatLimitReached: 'Limite posti raggiunto',
            subscriptionRequired: 'Abbonamento richiesto',
            paymentFailed: 'Pagamento fallito'
        },
        validation: {
            invalidEmail: 'Email non valida',
            invalidPhone: 'Numero di telefono non valido',
            invalidUrl: 'URL non valido',
            fieldRequired: 'Campo obbligatorio',
            fieldTooShort: 'Campo troppo corto',
            fieldTooLong: 'Campo troppo lungo',
            fieldInvalid: 'Campo non valido',
            passwordsDoNotMatch: 'Le password non corrispondono',
            emailTaken: 'Email già in uso',
            usernameTaken: 'Nome utente già in uso',
            phoneNumberTaken: 'Numero di telefono già in uso',
            domainTaken: 'Dominio già in uso'
        }
    },
    success: {
        generic: {
            saved: 'Salvato con successo',
            updated: 'Aggiornato con successo',
            created: 'Creato con successo',
            deleted: 'Eliminato con successo',
            sent: 'Inviato con successo',
            completed: 'Completato con successo',
            copied: 'Copiato negli appunti',
            uploaded: 'Caricato con successo',
            downloaded: 'Scaricato con successo',
            imported: 'Importato con successo',
            exported: 'Esportato con successo'
        },
        auth: {
            signedIn: 'Accesso effettuato con successo',
            signedUp: 'Registrazione completata con successo',
            signedOut: 'Disconnesso con successo',
            passwordChanged: 'Password cambiata con successo',
            passwordReset: 'Password reimpostata con successo',
            emailVerified: 'Email verificata con successo',
            phoneVerified: 'Telefono verificato con successo',
            mfaEnabled: 'Autenticazione a due fattori abilitata',
            mfaDisabled: 'Autenticazione a due fattori disabilitata',
            passkeyAdded: 'Passkey aggiunto con successo',
            passkeyRemoved: 'Passkey rimosso con successo',
            accountConnected: 'Account connesso con successo',
            accountDisconnected: 'Account disconnesso con successo'
        },
        organization: {
            created: 'Organizzazione creata con successo',
            updated: 'Organizzazione aggiornata con successo',
            deleted: 'Organizzazione eliminata con successo',
            memberInvited: 'Membro invitato con successo',
            memberRemoved: 'Membro rimosso con successo',
            roleChanged: 'Ruolo cambiato con successo',
            ownershipTransferred: 'Proprietà trasferita con successo',
            settingsUpdated: 'Impostazioni aggiornate con successo',
            domainVerified: 'Dominio verificato con successo',
            subscriptionUpdated: 'Abbonamento aggiornato con successo',
            paymentMethodUpdated: 'Metodo di pagamento aggiornato con successo'
        }
    },
    components: {
        loading: {
            generic: 'Caricamento...',
            signIn: 'Accesso in corso...',
            signUp: 'Registrazione in corso...',
            profile: 'Caricamento profilo...',
            organization: 'Caricamento organizzazione...',
            members: 'Caricamento membri...',
            settings: 'Caricamento impostazioni...',
            verification: 'Verifica in corso...',
            mfa: 'Verifica MFA...',
            passkey: 'Configurazione passkey...',
            oauth: 'Connessione OAuth...'
        },
        empty: {
            generic: 'Nessun dato disponibile',
            members: 'Nessun membro trovato',
            invitations: 'Nessun invito',
            sessions: 'Nessuna sessione attiva',
            devices: 'Nessun dispositivo registrato',
            notifications: 'Nessuna notifica',
            history: 'Nessuna cronologia',
            logs: 'Nessun log',
            search: 'Nessun risultato trovato',
            filter: 'Nessun elemento corrisponde ai filtri'
        },
        confirm: {
            delete: 'Sei sicuro di voler eliminare questo elemento?',
            remove: 'Sei sicuro di voler rimuovere questo elemento?',
            cancel: 'Sei sicuro di voler annullare?',
            logout: 'Sei sicuro di volerti disconnettere?',
            transfer: 'Sei sicuro di voler trasferire?',
            disable: 'Sei sicuro di voler disabilitare?',
            enable: 'Sei sicuro di voler abilitare?',
            reset: 'Sei sicuro di voler reimpostare?',
            clear: 'Sei sicuro di voler cancellare?',
            proceed: 'Vuoi procedere?',
            areYouSure: 'Sei sicuro?',
            cannotUndo: 'Questa azione non può essere annullata',
            permanentAction: 'Questa è un\'azione permanente'
        },
        help: {
            password: 'Usa almeno 8 caratteri con lettere, numeri e simboli',
            mfa: 'L\'autenticazione a due fattori aggiunge sicurezza extra',
            passkey: 'I passkey sono più sicuri delle password',
            backup: 'Salva i codici di backup in un posto sicuro',
            domain: 'Il dominio deve essere verificato per l\'uso',
            webhook: 'I webhook inviano notifiche in tempo reale',
            apiKey: 'Usa le chiavi API per l\'accesso programmatico',
            role: 'I ruoli determinano le autorizzazioni degli utenti',
            permission: 'I permessi controllano l\'accesso alle funzionalità',
            billing: 'La fatturazione viene elaborata mensilmente',
            usage: 'L\'utilizzo viene monitorato per il piano corrente'
        }
    }
};